import { useMutation, useQuery } from '@tanstack/react-query';
import { IArnoTop } from '../../Interfaces/IArnoTop';
import { customFetcher } from '../useFetch';
import { IArnoTopObject } from '../../Interfaces/IArnoTopObject';

//////////////////// ARNOtop
export const useGetARNOtopNoSync = () => {
  const {
    data: arnoTopNoSyncArray,
    isLoading: isLoadingArnoTopNoSyncArray,
    refetch: refetchArnoTopNoSyncArray,
  } = useQuery<IArnoTop[]>({
    refetchOnWindowFocus: false,
    queryKey: ['legalclient/arnotop/no_sync'],
    queryFn: () => customFetcher({ endpoint: `/legalclient/arnotop/no_sync` }),
  });

  return {
    arnoTopNoSyncArray,
    isLoadingArnoTopNoSyncArray,
    refetchArnoTopNoSyncArray,
  };
};

export const useCreateFromArnoTopNoSync = () => {
  const {
    mutateAsync: createFromArnoTopNoSync,
    isPending: isPendingCreateFromArnoTopNoSync,
  } = useMutation({
    mutationFn: (idArnoTop: number) =>
      customFetcher({
        endpoint: `/legalclient/arnotop/import/${idArnoTop}`,
      }),
  });

  return {
    createFromArnoTopNoSync,
    isPendingCreateFromArnoTopNoSync,
  };
};

export const useGetArnoTopObjects = (shouldFetch: boolean = true) => {
  const { data: arnoTopObjects, isLoading: isLoadingArnoTopObjects } = useQuery<
    IArnoTopObject[]
  >({
    refetchOnWindowFocus: false,
    queryKey: ['arnotopsync/arnotop_objects'],
    queryFn: () => customFetcher({ endpoint: '/arnotopsync/arnotop_objects' }),
    enabled: shouldFetch, // <<< WICHTIG
  });

  return {
    arnoTopObjects: arnoTopObjects ?? [],
    isLoadingArnoTopObjects,
  };
};

export const useGetArnoTopData = () => {
  const {
    data: arnoTopData,
    isLoading: isLoadingArnoTopData,
    refetch: refetchArnoTopData,
  } = useQuery<IArnoTop[]>({
    refetchOnWindowFocus: false,
    queryKey: ['legalclient/arnotop/get_all'],
    queryFn: () => customFetcher({ endpoint: '/legalclient/arnotop/get_all' }),
  });

  return { arnoTopData, isLoadingArnoTopData, refetchArnoTopData };
};
